import { APPROVER } from './../utils/constant';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStoreEnum } from '@shared/models/enum/local-store.enum';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStoreManagerService } from './../service/local-store-manager.service';
export interface MenuTag {
  color: string; // Background Color
  value: string;
}

export interface MenuChildrenItem {
  route: string;
  name: string;
  type: 'link' | 'sub' | 'extLink' | 'extTabLink';
  children?: MenuChildrenItem[];
}

export interface Menu {
  route: string;
  name: string;
  type: 'link' | 'sub' | 'extLink' | 'extTabLink';
  icon: string;
  label?: MenuTag;
  badge?: MenuTag;
  children?: MenuChildrenItem[];
}

export interface MenuParam {
  pId: number;
  customerCode: number;
  menuActive: MenuActive[];
}
export interface MenuActive {
  key: string;
  number: number;
  menuParam?: any[]
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menu$: BehaviorSubject<Menu[]> = new BehaviorSubject<Menu[]>([]);


  menusDform: any;
  menusEsb: any;

  constructor(private localStore: LocalStoreManagerService, private router: Router) {

  }

  getAll(): Observable<Menu[]> {
    return this.menu$.asObservable();
  }

  set(menu: Menu[]): Observable<Menu[]> {
    this.menu$.next(menu);
    return this.menu$.asObservable();
  }

  add(menu: Menu) {
    const tmpMenu = this.menu$.value;
    tmpMenu.push(menu);
    this.menu$.next(tmpMenu);
  }

  get menu() {
    return this.menu$.value ? this.menu$.value : [];
  }

  reset() {
    this.menu$.next([]);
  }

  /**
   * Convert menu show html
   * @param menuServer;
   * @param parentId;
   */
  mapMenu(menuServer, parentId = 0) {
    const menusEsb: any = [];
    let menuChild = menuServer.filter(x => x.parentId === parentId && x.active);
    menuChild = _.orderBy(menuChild, ['position'], ['asc']);
    (menuChild || []).forEach(element => {
      const menuSubChild = this.mapMenu(menuServer, element.id);
      const menu: any = {
        route: '/' + element.route?.trim(),
        name: element.name,
        type: menuSubChild.length > 0 ? 'sub' : 'link',
        icon: element.icon,
        children: menuSubChild
      };
      menusEsb.push(menu);
    });
    return menusEsb;
  }

  /**
   * Convert menu show html
   * @param menuServer;
   * @param parentId;
   */
  mapMenuTree(menuServer, parentId = 0) {
    const menusEsb: any = [];
    let menuChild = menuServer.filter(x => x.parentId === parentId);
    menuChild = _.orderBy(menuChild, ['position'], ['asc']);
    (menuChild || []).forEach(element => {
      const menuSubChild = this.mapMenuTree(menuServer, element.id);
      const menu: any = {
        route: '/' + element.route,
        name: element.name,
        type: menuSubChild.length > 0 ? 'sub' : element.route?.includes('/report/') ? 'extTabLink' : 'link',
        icon: element.icon,
        isData: true,
        children: menuSubChild
      };
      menusEsb.push(menu);
    });
    return menusEsb;
  }



  /**
   * kiểm tra quyền nhập hoặc duyệt để navigate
   */
  navigationEMB(flag = true) {
    const user = this.localStore.getData(LocalStoreEnum.User_Infor);
    if (user && user.authorities.includes('APPROVER')) {
      this.router.navigate(['emb/transaction-approval']);
      return;
    }
    if (user && user.authorities.includes('MAKER')) {
      this.router.navigate(['emb/corp-infor']);
      return;
    }
    if (flag) {
      this.router.navigate(['/']);
    }
  }

  /**
   * Naviagete sang url tương ứng của dform hoặc emb
   * @param returnUrl;
   */
  checkNavigate(returnUrl) {
    const menuDform: any[] = JSON.parse(localStorage.getItem(LocalStoreEnum.Menu_List));
    if (menuDform && menuDform.length > 0) {
      const userInfo = this.localStore.getData(LocalStoreEnum.User_Infor);
      const listCHECKER = userInfo.authorities.filter(x => x.toUpperCase() === APPROVER);
      if (listCHECKER.length > 0 && returnUrl === '/') {
        this.router.navigateByUrl('/dform/manage-record/customer-service');
      } else {
        this.router.navigateByUrl(returnUrl);
      }
      return true;
    } else {
      const menuEMB: any[] = JSON.parse(localStorage.getItem(LocalStoreEnum.Menu_List_EMB));
      if (menuEMB && menuEMB.length > 0) {
        this.navigationEMB(false);
        return true;
      }
    }

  }

  removeURLParameter(url) {
    url = url.split('?');
    if (url.length > 0) {
      return url[0];
    }
  }
}
